import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Ng5SliderModule } from 'ng5-slider';

import { RangeSliderComponent } from "./range-slider.component";

@NgModule({
  imports: [CommonModule, FormsModule, Ng5SliderModule],
  declarations: [RangeSliderComponent],
  exports: [RangeSliderComponent]
})
export class RangeSliderModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/range-slider/range-slider.module.ts